module.exports = __webpack_public_path__ + "img/badge-tm.628ceea6.svg";